import { MoreMenuIcon } from "@taunggyi-plus/design-system";
import { useId, useRef, useState } from "react";
import { useAuth } from "./provider";

export function SignOutButton({
  label = "Sign out",
  onDone,
  className = "more-menu-row",
}: {
  label?: string;
  onDone?: () => void;
  className?: string;
}) {
  const auth = useAuth();
  const dialog = useRef<HTMLDialogElement>(null);
  const title = useId();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  return (
    <>
      <button
        type="button"
        className={className}
        style={{ color: "#ffaaa2" }}
        onClick={() => {
          setError("");
          dialog.current?.showModal();
        }}
      >
        {className.includes("more-menu-row") ? (
          <>
            <MoreMenuIcon name="sign-out" />
            <strong>{label}</strong>
            <b aria-hidden="true">›</b>
          </>
        ) : (
          label
        )}
      </button>
      <dialog
        ref={dialog}
        className="customer-order-filter-dialog subscription-popup sign-out-dialog"
        aria-labelledby={title}
        onCancel={(event) => {
          if (busy) event.preventDefault();
        }}
      >
        <h3 id={title}>{label}</h3>
        <p>Sign out of TaungGyi Link on this device?</p>
        {error && <p role="alert">{error}</p>}
        <div style={{ display: "grid", gap: 12, marginTop: 24 }}>
          <button
            type="button"
            className="button"
            style={{ background: "#351f2a", color: "#ffaaa2" }}
            disabled={busy}
            onClick={() => {
              setBusy(true);
              setError("");
              void auth
                .signOut()
                .then(() => {
                  dialog.current?.close();
                  onDone?.();
                })
                .catch((failure: unknown) =>
                  setError(failure instanceof Error ? failure.message : "Please try again."),
                )
                .finally(() => setBusy(false));
            }}
          >
            {busy ? "Please wait…" : label}
          </button>
          <button
            type="button"
            className="button button--secondary"
            disabled={busy}
            onClick={() => dialog.current?.close()}
          >
            Cancel
          </button>
        </div>
      </dialog>
    </>
  );
}
